
  import * as ipxRuntime$cY2pXWYpbVROk60rxLsbDODWCdPKE9hZaoqwdgIkr5M from '/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.2_ioredis@5.8.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as ipxStaticRuntime$u3eVLHPgI4aqlafs2pQvFcrQJcDNaRs8J_45Ie009EEB4 from '/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.2_ioredis@5.8.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$cY2pXWYpbVROk60rxLsbDODWCdPKE9hZaoqwdgIkr5M, defaults: {"modifiers":{"quality":80,"format":"webp"}} },
  ['ipxStatic']: { provider: ipxStaticRuntime$u3eVLHPgI4aqlafs2pQvFcrQJcDNaRs8J_45Ie009EEB4, defaults: {"modifiers":{"quality":80,"format":"webp"}} }
    }
  }
